export default {
  cookieExpires: 1,
  useFingerPrint: true,
  mobAppActiveGroup: 9241, //# golomt
  appForce: 0,

  ////gosmart server
  //hubBaseUrl: 'https://mobcoreapi.gosmart.mn/',
  hubBaseUrl: "",
  resBaseUrl: "https://res.gosmart.mn/",
  // resBaseUrl: "http://103.11.195.40:8086/",
  
  // resBaseUrl: "https://lms-cdn.golomtbank.local/",
  // resBaseUrl: "https://lms-cdn.golomtbank.com/",

  lmsPages: [
    "lmsWelcome",
    "lmsProfile",
    "lmsParticipant",
    "lmsCourses",
    "lmsCourseView",
    "lmsLessonView",
    "lmsAttend",
    "lmsCalendar",
    "lmsCalendarTeacher",
    "lmsLibrary",
    "lmsDashboard",
    "lmsNotif",
    "lmsPaymentDetail",
    "lmsPaymentList",
    "lmsEventDetail",
    "lmsEventList",
    "lmsMembership",
    "lmsMembershipEthic",
    "lmsMembershipOrg",
    "lmsMembershipPayment",
    "lmsResearchList",
    "lmsNewsList",
    "lmsMagazineList",
    "lmsLegalList",
    "lmsAuditLicenseRequest",
    ,
    "lmsFeedback",
    "lmsOffline",
    "lmsConfirm",
    //# TODO admin yed hamaarahgui
    "userProfile",
    "lmsContact",

    "lmsSanamj",
    "lmsAssign"
  ],

  stfPages: [
    'stfResearcher', 
    'stfCalendar', 
    'stfResearcherList', 
    'stfAdDetail', 
    'stfAdApply',

    'dzHome',
    'dzAdDetail',
    'dzAdApply'
],

elfPages: [
  'elfStudent', 'elfScholarship'
],

  mobApps: [
    {
      id: 9241,
      key: "FUCYnR1jOEqpd_SfjmPWOw",
      name: "For Developers",
      logo: "media/logo/onoo.png",
      bgLogin: "assets/img/covid.svg",
      hostPro: ["dev.gosmart.mn"],
      hostDev: [
        "192.168.1.5:80380",
        "192.168.0.105:80801",
        "192.168.0.115:8x080",
        "192.168.42.2:8087",
        "192.168.0.100:8080s"
      ],
      fileUploadSize: {
        default: {
          size: 1048576,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 1гб байна."
        },
        student: {
          size: 30720,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 30мб байна."
        }
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      hubBaseUrl: "https://app.gosmart.mn/coredev/",
      register: true,
      helpPageUrl: "http://help.gosmart.mn",
      streamBaseUrl: "https://stream-gate.gosmart.mn/",
      baseUrl: "https://devapi.gosmart.mn/"
    },
    {
      // id: 9241, //# for gosmart connect
      // key: 'FUCYnR1jOEqpd_SfjmPWOw',
      id: 9249,
      key: "k1P0nf1qAkGwRXB6L4Q8_Q",
      name: "Академи",
      logo: "media/logo/golomt.png",
      logoFooter: "assets/img/golomt/logo-footer.png",
      skin: "is-golomt",
      publicPage: {
        has: true,
        route: "landingPage"
      },
      learnConfig: {
        course: {
          showAlert: false
        }
      },
      hostPro: [
        "academy.golomtbank.local",
        "academy.golomtbank.com",
        "lmsuat.golomtbank.local",
        "uat-academy.golomtbank.local",
        "lmsdemo.gosmart.mn",
        "golomt.gosmart.mn",
        "sandboxgolomt.gosmart.mn",
        "192.168.205.46",
        "192.168.1.82"
      ],
      hostDev: [
        "172.20.10.3:800802",
        "192.168.1.13:8080",
        "192.168.1.5:8080",
        "192.168.0.115:80x80",
        "192.168.0.105:80809",
        "192.168.0.100:8080_x",
        "192.168.42.173:8080",
        "192.168.1.10:8080",
        "10.0.0.78:8080",
        //"192.168.0.178:8080" 
      ],
      register: false,
      fileUploadSize: {
        default: {
          size: 1048576,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 1гб байна."
        },
        student: {
          size: 204800,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 200мб байна."
        }
      },

      helpPageUrl: "https://lms-help.golomtbank.local",
      streamBaseUrl: "https://lms-stream.golomtbank.local:8443/",
      reportBaseUrl: "https://lms-doc.golomtbank.local/",
      PDFJS_URL:
        "https://lms-cdn.golomtbank.local/static/pdfobject/web/viewer.html",
      cdnBaseUrl: "https://lms-cdn.golomtbank.local/",
      hubBaseUrl: "https://lms-stream.golomtbank.local/",
      baseUrl: "https://academy.golomtbank.local/core/",
      resBaseUrl: "https://lms-cdn.golomtbank.local/",
 
      // helpPageUrl: "https://lms-help.golomtbank.com",
      // streamBaseUrl: 'https://lms-stream.golomtbank.com:8443/',
      // reportBaseUrl: 'https://lms-doc.golomtbank.com/',
      // PDFJS_URL: 'https://lms-cdn.golomtbank.com/static/pdfobject/web/viewer.html',
      // cdnBaseUrl: 'https://lms-cdn.golomtbank.com/',
      // hubBaseUrl: 'https://lms-stream.golomtbank.com/',
      // baseUrl: 'https://academy.golomtbank.com/core/',
      // resBaseUrl: 'https://lms-cdn.golomtbank.com/',
    },
    {
      id: 98,
      name: "Гөү смарт ТМ ХХК",
      key: "zIGhSWMcrLTeOUvByGtMr1",
      logo: "media/icon.png",
      skin: "",
      publicPage: {
        //has: false,
        has: true,
        route: "landingHelp"
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      hostPro: [
        "help.gosmart.mn",
        "edu-help.judcouncil.mn",
        "v3.gosmart.mn",
        "192.168.205.46:7050",
        "lmsuat.golomtbank.local:5050"
      ],
      hostDev: [
        "192.168.0.115:80080",
        "192.168.0.105:80802",
        "192.168.42.2:80808",
        "192.168.0.100:80801", "192.168.0.161:8080_a","192.168.0.164:8080_s",
        "192.168.1.5:80803"
      ],
      fileUploadSize: {
        default: {
          size: 204800,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 200мб байна."
        },
        student: {
          size: 102400,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 100мб байна."
        }
      },
      helpPageUrl: "http://help.gosmart.mn",
      streamBaseUrl: "https://stream-gate.gosmart.mn/",
      hubBaseUrl: "https://app.gosmart.mn/coredev/",
      baseUrl: "https://devapi.gosmart.mn/"
    },
    {
      id: 9157,
      name: "ММНБИ",
      key: "iN2VmYTU1OS0xMTViLTxzc",
      logo: "media/logo/monicpa_mini.jpg",
      bgLogin: "assets/img/monicpa.jpg",
      hostPro: ["dynamic.monicpa.mn", "monicpa.gosmart.mn"],
      hostDev: [
        "192.168.0.115:80x80",
        "192.168.0.105:80807",
        "192.168.0.100:8080_x","192.168.0.173:8080_2", "192.168.0.171:808_0",
        "192.168.1.2:8081",
        "192.168.42.2:8089",
        "192.168.0.169:8080__2"
      ],
      fileUploadSize: {
        default: {
          size: 1536000,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 1.5GB байна."
        },
        student: {
          size: 30720,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 30мб байна."
        }
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      register: true,
      helpPageUrl: "http://help.gosmart.mn",
      v2BaseUrl: "http://office.monicpa.mn",
      streamBaseUrl: "https://stream-gate.gosmart.mn/",
      hubBaseUrl: "https://dynamic.monicpa.mn/core/",
      //baseUrl: 'https://devapi.gosmart.mn/', 
      baseUrl: "https://dynamic.monicpa.mn/mobcore/"
    },
    {
      id: 6126,
      name: "МУТМЗН",
      key: "JOI7zQxTsAZZXS21cEbaPq",
      logo: "media/logo/tmz.png",
      //bgLogin: "assets/img/img15.png",
      bgLogin: "assets/img/cpta.png",
      hostPro: ["members.cpta.mn", "cpta.gosmart.mn"],
      hostDev: [
        "192.168.1.151:8080",
        "172.20.10.3:80800",
        "192.168.0.105:80802",
        "192.168.0.115:80880",
        "192.168.1.5:80800",
        "192.168.42.2:8089",
        "192.168.0.100:8080_2", "192.168.0.173:8080_s"
      ],
      publicPage: {
        has: true,
        route: "landingPage"
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      fileUploadSize: {
        default: {
          size: 1536000,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 1.5GB байна."
        },
        student: {
          size: 30720,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 30мб байна."
        }
      },
      register: true,
      helpPageUrl: "http://help.gosmart.mn", v2BaseUrl: "http://cpta.gosmart.mn",
      streamBaseUrl: "https://stream-gate.gosmart.mn/",
      hubBaseUrl: "https://app.gosmart.mn/coreTMZ/",
      baseUrl: "https://members.cpta.mn/mobcore/"
    },
    {
      id: 9161,
      key: "cAtbPfwB2VFwAMX3lm1Z0H",
      name: "ММҮИ",
      logo: "media/logo/mica.jpg",
      skin: "",
      publicPage: {
        has: false,
        route: "landingPage"
      },
      learnConfig: {
        course: {
          showAlert: false
        }
      },
      hostPro: ["v3.mica.gosmart.mn"],
      hostDev: [
        "192.168.0.115:80801",
        "192.168.0.105:80801",
        "192.168.0.100:80803",
        "192.168.42.2:80803",
        "192.168.1.5:80803"
      ],
      register: true,
      fileUploadSize: {
        default: {
          size: 1536000,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 1.5GB байна."
        },
        student: {
          size: 30720,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 200мб байна."
        }
      },
      helpPageUrl: "https://lms-help.golomtbank.local",
      streamBaseUrl: "https://stream-gate.gosmart.mn/"
    },
    {
      id: 9166,
      name: "Номин холдинг",
      key: "a_qkflbHjU_np4KIz_eImP",
      logo: "media/logo/nomin.jpg",
      bgLogin: "assets/img/img15.png",
      hostPro: ["nomin.gosmart.mn"],
      hostDev: [
        "192.168.0.105:80820",
        "192.168.42.2:80809",
        "192.168.0.100:8080_s"
      ],
      fileUploadSize: {
        default: {
          size: 1536000,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 1.5GB байна."
        },
        student: {
          size: 30720,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 30мб байна."
        }
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      register: false,
      helpPageUrl: "http://help.gosmart.mn",
      streamBaseUrl: "https://stream-gate.gosmart.mn/",
      hubBaseUrl: "https://nomin.gosmart.mn/core/",
      baseUrl: "https://nomin.gosmart.mn/mobcore/"
      //baseUrl: 'https://devapi.gosmart.mn/',
    },
    {
      id: 9226,
      name: "Moore Audit",
      key: "N0lyUq26NkeOPob6u8unmg",
      logo: "media/logo/moore.png",
      bgLogin: "assets/img/img15.png",
      hostPro: ["mooreaudit.gosmart.mn"],
      hostDev: ["192.168.0.115:80808", "192.168.0.105:80808", "192.168.42.2:80802"],
      fileUploadSize: {
        default: {
          size: 1536000,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 1.5GB байна."
        },
        student: {
          size: 30720,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 30мб байна."
        }
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      register: true,
      helpPageUrl: "http://help.gosmart.mn",
      streamBaseUrl: "https://stream-gate.gosmart.mn/"
    },
    {
      id: 9231,
      name: "BizGuide",
      key: "dQXUXRo_zE6OJ6kXSw0_OA",
      skin: "is-bizguide",
      publicPage: {
        has: true,
        route: "landingPage"
      },
      logo: "media/logo/bizguide.png",
      logoFooter: "assets/img/bizguide/logo-footer.png",
      bgLogin: "assets/img/img15.png",
      hostPro: ["learning.bizguide.mn", "learning.bizguide.mn"],
      hostDev: ["192.168.0.105:80801"],
      fileUploadSize: {
        default: {
          size: 1536000,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 1.5GB байна."
        },
        student: {
          size: 30720,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 30мб байна."
        }
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      register: true,
      helpPageUrl: "http://help.gosmart.mn",
      streamBaseUrl: "https://stream-gate.gosmart.mn/"
    },
    {
      id: 9234,
      name: "Бяцхан тоочид",
      key: "xlM9EBJS4UOJholOygbWyw",
      logo: "media/logo/eboard.png",
      bgLogin: "assets/img/img15.png",
      hostPro: ["eboard.gosmart.mn"],
      hostDev: ["192.168.42.2:80809"],
      fileUploadSize: {
        default: {
          size: 1536000,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 1.5GB байна."
        },
        student: {
          size: 30720,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 30мб байна."
        }
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      register: true,
      helpPageUrl: "http://help.gosmart.mn",
      streamBaseUrl: "https://stream-gate.gosmart.mn/"
    },
    {
      id: 9162,
      name: "Бичил глобус",
      key: "bANNURFrgQOmLOrt8DHpTi",
      logo: "media/logo/bichil.png",
      bgLogin: "assets/img/img15.png",
      hostPro: ["bg.gosmart.mn"],
      hostDev: ["192.168.42.2:80809"],
      fileUploadSize: {
        default: {
          size: 1536000,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 1.5GB байна."
        },
        student: {
          size: 30720,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 30мб байна."
        }
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      register: true,
      helpPageUrl: "http://help.gosmart.mn",
      streamBaseUrl: "https://stream-gate.gosmart.mn/"
    },
    {
      id: 9240,
      name: "Архивын Ерөнхий газар",
      key: "GYwwpUowV0uPVAOtqg2vcA",
      logo: "media/logo/archives.png",
      bgLogin: "assets/img/img15.png",
      hostPro: ["archives.gosmart.mn"], 
      hostDev: ["192.168.0.115:80x80", "192.168.42.2:80809",
      , "192.168.0.100:8080_1"],
      fileUploadSize: {
        default: {
          size: 1536000,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 1.5GB байна."
        },
        student: {
          size: 30720,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 30мб байна."
        }
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      register: true,
      helpPageUrl: "http://help.gosmart.mn",
      streamBaseUrl: "https://stream-gate.gosmart.mn/"
    },
    {
      id: 1104,
      //name: "Төрийн албаны цахим сургалт",
      //logo: "media/logo/soyombo.png",
      //name: "Динамик Цахим сургалтын платформ",
      name: "Цахим сургалт",
      //logo: "media/logo/onoo.png",
      logo: "media/logo/soyombo.png",
      bgLogin: "assets/img/covid.svg",
      skin: "gov",
      key: "oXSBUpThuoeNxcra7HH3Em",
      hostPro: [
        "demo.gosmart.mn",
        "learning.bizguide.mn",
        "lms.onoo.mn",
        "new.onoo.mn"
      ],
      hostDev: [
        "192.168.0.115:80x80",
        "192.168.1.5:8080",
        "172.20.10.3:80800",
        "192.168.0.105:80800",
        "192.168.42.2:8087",
        "192.168.0.100:8080", "192.168.0.168:8080_x", "192.168.0.171:8080_2",  "192.168.0.161:8080_2"
      ],
      fileUploadSize: {
        default: {
          size: 1048576,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 1гб байна."
        },
        student: {
          size: 30720,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 30мб байна."
        }
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      register: false,
      helpPageUrl: "http://help.gosmart.mn",
      streamBaseUrl: "https://stream-gate.gosmart.mn/",
      hubBaseUrl: "https://app.gosmart.mn/coredev/",
      baseUrl: "https://devapi.gosmart.mn/"
    },
    {
      id: 9233,
      name: "Мал эмнэлгийн ерөнхий газар",
      key: "HMk8BCDrIEe1hxj6f6JQyA",
      hostPro: ["vetdrug.mn", "www.vetdrug.mn"],
      hostDev: ["192.168.0.105:80801", "192.168.0.100:8080_1"],
      // publicPage: {
      //   has: true,
      //   route: 'vet-med'
      // },

      hasHomePage: true,
      defaultHome: "vet-med",
      helpPageUrl: "http://help.gosmart.mn",
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      streamBaseUrl: "https://stream-gate.gosmart.mn/"
    },
    {
      id: 9237,
      name: "asset.ubtraffic",
      key: "o_usZfT6uEqqyNdRP5vVpg",
      helpPageUrl: "http://help.gosmart.mn",
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      logo: "media/logo/ubtraffic.png",
      logoFooter: "assets/img/ubtraffic/logo-footer.png",
      skin: "",
      publicPage: {
        has: false,
        route: 'landingPage'
      },
      hostPro: ['asset.gosmart.mn', 'asset.ubtraffic.mn'],
      hostDev: ['192.168.0.115:80840', '192.168.0.105:80801', 
      '192.168.0.100:8080_2', '192.168.0.173:8080_2', '192.168.0.161:8080',  '192.168.0.164__:8080',
      '192.168.42.2:8081', 
      '192.168.1.5:80809'],
      register: true,
      fileUploadSize: {
        default: {
          size: 1048576,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 1гб байна."
        },
        student: {
          size: 204800,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 200мб байна."
        }
      },

      register: false,
      helpPageUrl: "http://help.gosmart.mn",
      hasStreamServer: false,
      streamBaseUrl: "https://stream-gate.gosmart.mn/",
      // hubBaseUrl: "https://app.gosmart.mn/coredev/",
      // baseUrl: "https://devapi.gosmart.mn/"
    },
    {
      id: 9238,
      name: "zhut.report",
      key: "U1ZjGhgPIE_unNxET2TYwQ",
      helpPageUrl: "http://help.gosmart.mn",
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      streamBaseUrl: "https://stream-gate.gosmart.mn/"
    },
    {
      id: 9250,
      key: "KFCTQHTYZESz0hBJnqclzQ",
      name: "Голомт Академи",
      logo: "media/logo/golomt.png",
      skin: "",
      publicPage: {
        has: true,
        route: "landingHelp"
      },
      hostPro: ["lms-help.golomtbank.local"],
      hostDev: [
        "192.168.42.2:8081",
        "192.168.0.105:80802",
        "192.168.0.100:80802",
        "192.168.1.5:80804"
      ],
      fileUploadSize: {
        default: {
          size: 204800,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 200мб байна."
        },
        student: {
          size: 102400,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 100мб байна."
        }
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      helpPageUrl: "https://lms-help.golomtbank.local",
      streamBaseUrl: "https://lms-stream.golomtbank.local:8443/",
      reportBaseUrl: "https://lms-doc.golomtbank.local/",
      PDFJS_URL:
        "https://lms-cdn.golomtbank.local/static/pdfobject/web/viewer.html",
      cdnBaseUrl: "https://lms-cdn.golomtbank.local/",
      hubBaseUrl: "https://lms-stream.golomtbank.local/",
      baseUrl: "https://academy.golomtbank.local/core/",
      resBaseUrl: "https://lms-cdn.golomtbank.local/"
    },
    {
      id: 9245,
      name: "Нийгмийн даатгал",
      logo: "media/logo/ndaatgal.jpg",
      bgLogin: "assets/img/img15.png",
      skin: "",
      key: "7CuefISBZE6y1I2Zkt1XtQ",

      hostPro: ["nd.gosmart.mn", "www.nd.gosmart.mn"],
      hostDev: [
        "192.168.0.115:80860",
        "192.168.0.105:80801",
        "192.168.0.100:80802", "192.168.0.173:8080", "192.168.0.168:8080_2",
        "192.168.42.2:8080",
        "192.168.1.5:808120"
      ],
      register: true,
      fileUploadSize: {
        default: {
          size: 1048576,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 1гб байна."
        },
        student: {
          size: 102400,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 100мб байна."
        }
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      helpPageUrl: "http://help.gosmart.mn",
      hasStreamServer: false,
      streamBaseUrl: "https://stream-gate.gosmart.mn/",
      hubBaseUrl: "https://nd.gosmart.mn/core/",
      baseUrl: "https://nd.gosmart.mn/mobCore/"
    },

    {
      id: 9293,
      name: "Нийгмийн даатгал",
      logo: "media/logo/ndaatgal.jpg",
      bgLogin: "assets/img/img15.png",
      skin: "",
      key: "huD_gxG1X06PKZ6Po2Rw_A",

      hostPro: ["surgalt.ndaatgal.mn"],
      hostDev: [
        "192.168.0.115:8080x0",
      ],
      register: true,
      fileUploadSize: {
        default: {
          size: 1048576,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 1гб байна."
        },
        student: {
          size: 102400,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 100мб байна."
        }
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      helpPageUrl: "http://help.gosmart.mn",
      hasStreamServer: false,
      streamBaseUrl: "https://stream-gate.gosmart.mn/",
      hubBaseUrl: "https://nd.gosmart.mn/core/",
      baseUrl: "https://nd.gosmart.mn/mobCore/"
    },

    {
      id: 9246,
      name: "Muren",
      logo: "https://res.gosmart.mn/media/icon.png",
      bgLogin: "assets/img/img15.png",
      skin: "",
      key: "8EnZS_dGbkipGzqRPPMsgA",

      hostPro: ["muren.gosmart.mn"],
      hostDev: ["192.168.0.105:8082", "192.168.0.100:808096"],
      register: true,
      fileUploadSize: {
        default: {
          size: 204800,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 200мб байна."
        },
        student: {
          size: 102400,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 100мб байна."
        }
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      helpPageUrl: "http://help.gosmart.mn",
      streamBaseUrl: "https://stream-gate.gosmart.mn/"
    },
    {
      id: 9247,
      name: "Монголын Үндэсний <br />Мал Эмнэлгийн Холбоо",
      logo: "media/logo/mvma.png",
      skin: "is-mvma",
      logoFooter: "",
      publicPage: {
        has: true,
        route: "landingPage"
      },
      key: "IpHO1B8Q4EyqfNRuTJaTHg",
      hostPro: ["mvma.gosmart.mn", "vet-edu.mn", "www.vet-edu.mn"],
      hostDev: [
        "192.168.0.105:80801",
        "192.168.0.100:80801",
        "192.168.1.5:808120",
        "192.168.42.2:80808"
      ],
      register: true,
      fileUploadSize: {
        default: {
          size: 204800,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 200мб байна."
        },
        student: {
          size: 102400,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 100мб байна."
        }
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      helpPageUrl: "http://help.gosmart.mn",
      v2BaseUrl: "http://app.gosmart.mn",
      streamBaseUrl: "https://stream-gate.gosmart.mn/"
    },
    {
      id: 9235,
      name: "Зүтгүүрийн аж ахуйн алба",
      logo: "media/logo/ubtz2023.png",
      bgLogin: "assets/img/img15.png",
      skin: "",
      key: "OorU4s35GE_30FR_ubbdwA",

      hostPro: ["railway.gosmart.mn", "my-railway.com", "www.my-railway.com",],
      hostDev: [
        "192.168.1.7:80x80",
        "192.168.0.105:8080_s",
        "192.168.0.115:80c80",
        "192.168.0.100:8080_j",
        "192.168.42.2:8081",
        "192.168.0.100:8080_tch",
        "192.168.0.178:8080_x",
        "172.20.10.3:8080"
      ],
      fileUploadSize: {
        default: {
          size: 1048576,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 1гб байна."
        },
        student: {
          size: 1,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 1kb байна."
        }
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      helpPageUrl: "http://help.gosmart.mn",
      streamBaseUrl: "https://stream-gate.gosmart.mn/",
      // hubBaseUrl: 'https://www.my-railway.com/core/',
      // baseUrl: 'https://my-railway.com/mobCore/',
      v2BaseUrl: "https://v2.railway.gosmart.mn",
      hubBaseUrl: 'https://railway.gosmart.mn/core/',
      baseUrl: 'https://railway.gosmart.mn/mobCore/',
    },
    {
      id: 9132,
      //name: "Соёл урлагийн их сургууль",
      name: "СУИС",
      logo: "media/logo/mnuac-mini.png",
      bgLogin: "assets/bg/mnuac.png",
      skin: "",
      key: "xFo2zg983Esakr6rtQEu2Q",
      hostPro: ["open.mnuac.edu.mn", "smart.mnuac.edu.mn", 'openmnuac.gosmart.mn'],
      hostDev: ["192.168.0.115:80x80",
      "192.168.0.163:8080"],
      fileUploadSize: {
        default: {
          size: 1048576,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 1гб байна."
        },
        student: {
          size: 30720,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 30мб байна."
        }
      },
      publicPage: {
        has: true,
        route: "mnuac"
      },
      learnConfig: {
        course: {
          showAlert: true,
          thumb: {
            orientation: 'landscape',
            mode: 'crop'
          }
        }
      },
      //tvr haav
      register: false,

      helpPageUrl: "http://smart.mnuac.edu.mn",
      v2BaseUrl: "http://office.mnuac.edu.mn",
      streamBaseUrl: "https://stream-gate.gosmart.mn/",
      hasStreamServer: false,
      hubBaseUrl: "https://app.gosmart.mn/coreMNUAC/",
      baseUrl: "https://mobcoremnuac.gosmart.mn/"
    },
    {
      id: 9229,
      name: "Соёл урлагийн их сургууль",
      logo: "media/logo/mnuac-mini.png",
      bgLogin: "assets/bg/mnuac.png",
      skin: "",
      key: "u4q70iDUM024Uug21mY_5A",
      hostPro: ["surgalt.mnuac.edu.mn"],
      hostDev: ["192.168.0.105:80880"],
      fileUploadSize: {
        default: {
          size: 1048576,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 1гб байна."
        },
        student: {
          size: 30720,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 30мб байна."
        }
      },
      publicPage: {
        has: true,
        route: "landingPage"
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      register: true,

      helpPageUrl: "http://smart.mnuac.edu.mn",
      v2BaseUrl: "http://office.mnuac.edu.mn",
      streamBaseUrl: "https://stream-gate.gosmart.mn/",
      hubBaseUrl: "https://app.gosmart.mn/coreMNUAC/",
      baseUrl: "https://mobcoremnuac.gosmart.mn/"
    },
    {
      id: 9251,
      name: "ГрэйпСити Монгол",
      logo: "media/logo/grapecity_mini.png",
      bgLogin: "assets/img/orgs/grapecity.png",
      skin: "",
      key: "125LWBl5OkSL0axKGzSIyQ",
      hostPro: ["grapecity.gosmart.mn"],
      hostDev: ["192.168.0.105:80801"],
      fileUploadSize: {
        default: {
          size: 1048576,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 1гб байна."
        },
        student: {
          size: 30720,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 30мб байна."
        }
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      register: true,
      helpPageUrl: "http://help.gosmart.mn",
      streamBaseUrl: "https://stream-gate.gosmart.mn/"
    },
    {
      id: 9252,
      name: "ХХҮЕГ",
      logo: "media/logo/halamj.png",
      bgLogin: "assets/img/covid.svg",
      skin: "",
      key: "1KPU_UlFH0eSKjt2_SGn1g",
      hostPro: ["halamj.gosmart.mn"],
      hostDev: ["192.168.0.105:80801"],
      fileUploadSize: {
        default: {
          size: 2048000,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 2GB байна."
        },
        student: {
          size: 30720,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 30мб байна."
        }
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      //register: true,
      helpPageUrl: "http://help.gosmart.mn",
      streamBaseUrl: "https://stream-gate.gosmart.mn/",
      hubBaseUrl: "https://halamj.gosmart.mn/core/",
      baseUrl: "https://halamj.gosmart.mn/mobCore/"
    },
    {
      id: 9254,
      name: "Удирдлагын академи",
      logo: "media/logo/noah.png",
      bgLogin: "assets/img/state.png",
      //bgLogin: "assets/img/mesp.png",
      skin: "is-state",
      key: "Ow9wnhp88kGyJbJHLeh1ww",
      hostPro: [
        "surgalt.gov.mn",
        "state.gosmart.mn",
        "academy.gosmart.mn",
        "192.168.0.105:701"
      ],
      hostDev: [
        "192.168.0.115:80x80",
        "192.168.0.105:80801",
        "192.168.0.105:701",
        "192.168.0.100:80801", '192.168.0.171:80800'
      ],
      fileUploadSize: {
        default: {
          size: 1048576,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 1гб байна."
        },
        student: {
          size: 30720,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 30мб байна."
        }
      },
      publicPage: {
        has: true,
        route: "landingPage"
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      register: true,
      helpPageUrl: "http://help.gosmart.mn",
      hasStreamServer: false,
      streamBaseUrl: "https://stream-academy-ssl.gosmart.mn/",
      reportBaseUrl: "https://academy-report.gosmart.mn/",
      PDFJS_URL: "https://surgalt.gov.mn/pdfobject/web/viewer.html",
      cdnBaseUrl: "https://academy-cdn.gosmart.mn/",
      hubBaseUrl: "https://surgalt.gov.mn/core/",
      baseUrl: "https://surgalt.gov.mn/mobCore/"
    },
    {
      id: 9256,
      name: "Training Hub",
      logo: "media/icon.png",
      bgLogin: "assets/img/covid.svg",
      skin: "",
      key: "Sv_RD56LTEWyS_4krRvW6A",
      hostPro: ["traininghub.gosmart.mn"],
      hostDev: ["192.168.0.115:808x0", "192.168.0.105:80801", "192.168.0.100:80801", 
      "192.168.0.167:8080", "192.168.0.186:8080", "192.168.0.164:8080"],
      fileUploadSize: {
        default: {
          size: 1048576,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 1гб байна."
        },
        student: {
          size: 30720,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 30мб байна."
        }
      },
      publicPage: {
        has: false,
        route: "landingPage"
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      register: true,
      helpPageUrl: "http://help.gosmart.mn",
      streamBaseUrl: "https://stream-gate.gosmart.mn/",

      hubBaseUrl: "https://traininghub.gosmart.mn/core/",
      baseUrl: "https://traininghub.gosmart.mn/mobCore/"
    },
    {
      id: 9308,
      name: "Санхүү, Татварын онлайн тестийн систем",
      logo: "media/logo/so-0627.png",
      bgLogin: "assets/img/covid.svg",
      skin: "",
      key: "zEwrHoU9_kaLwWdrxdgVHg",
      hostPro: ["test.gosmart.mn"],
      hostDev: ["192.168.0.115:80x80", "192.168.0.105:80801", "192.168.0.100:80801"],
      fileUploadSize: {
        default: {
          size: 1048576,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 1гб байна."
        },
        student: {
          size: 30720,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 30мб байна."
        }
      },
      publicPage: {
        has: false,
        route: "landingPage"
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      register: true,
      helpPageUrl: "http://help.gosmart.mn",
      streamBaseUrl: "https://stream-gate.gosmart.mn/",

      hubBaseUrl: "https://traininghub.gosmart.mn/core/",
      baseUrl: "https://traininghub.gosmart.mn/mobCore/"
    },

    {
      id: 9253,
      name: "Тээврийн автомашины дарааллын систем",
      logo: "media/logo/tads.png",
      skin: "is-tads",
      logoFooter: "",
      publicPage: {
        has: false,
        route: "landingTads"
      },
      key: "aal8X8oVMkW9CVK0bwCS3g",
      hostPro: ["tads.gosmart.mn"],
      hostDev: [
        "192.168.0.105:80801",
        "192.168.0.100:80801",
        "192.168.1.5:8080y",
        "192.168.42.2:80808"
      ],
      //register: true,
      fileUploadSize: {
        default: {
          size: 5120,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 5мб байна."
        },
        student: {
          size: 102400,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 100мб байна."
        }
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      helpPageUrl: "http://help.gosmart.mn",
      streamBaseUrl: "https://stream-gate.gosmart.mn/"
    },
    {
      id: 100,
      name: "Зайн сургалтын систем",
      key: "TXImUpThuPeVxcrt1QH3Ev",
      logo: "media/logo/mta.svg",
      bgLogin: "assets/img/covid.svg",
      hostPro: ["e-learning.mta.mn"],
      hostDev: ["192.168.0.115:80804", "192.168.0.105:80802", "192.168.42.2:80809"],
      fileUploadSize: {
        default: {
          size: 2048000,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 2GB байна."
        },
        student: {
          size: 2048000,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 2GB байна."
        }
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      register: false,
      helpPageUrl: "http://help.gosmart.mn",
      hasStreamServer: false,
      streamBaseUrl: "https://stream-gate.gosmart.mn/",
      PDFJS_URL: "https://cdn.mta.mn/pdfobject/web/viewer.html",
      hubBaseUrl: "https://e-learning.mta.mn/core/",
      baseUrl: "https://e-learning.mta.mn/mobCore/"
    },
    {
      id: 9257,
      name: "Болорболд",
      key: "lD_H42EAqUG1OIxd96UNlw",
      logo: "media/logo/bolorbold.png",
      bgLogin: "assets/img/covid.svg",
      hostPro: ["bolorbold.gosmart.mn"],
      hostDev: ["192.168.1.10:80801", "192.168.42.2:80809"],
      fileUploadSize: {
        default: {
          size: 2048000,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 2GB байна."
        },
        student: {
          size: 102400,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 100MB байна."
        }
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      register: true,
      helpPageUrl: "http://help.gosmart.mn",
      streamBaseUrl: "https://stream-gate.gosmart.mn/"
    },
    {
      id: 9258,
      name: "RS2 Consulting",
      key: "qfPEUNVov0STDXrAcyshxg",
      logo: "media/logo/rs2.jpg",
      bgLogin: "assets/img/covid.svg",
      hostPro: ["rs2.gosmart.mn"],
      hostDev: ["192.168.1.10:80801", "192.168.42.2:80809"],
      fileUploadSize: {
        default: {
          size: 2048000,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 2GB байна."
        },
        student: {
          size: 102400,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 100MB байна."
        }
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      register: true,
      helpPageUrl: "http://help.gosmart.mn",
      streamBaseUrl: "https://stream-gate.gosmart.mn/"
    },
    {
      id: 9259,
      name: "Орчлон сургууль",
      key: "22HVuYbPRk_ZHdD9yBr5dg",
      logo: "media/logo/orchlon.png",
      bgLogin: "assets/img/orchlon.png",
      skin: "is-orchlon",
      hostPro: ["time.orchlon.mn", "orchlon.gosmart.mn"],
      hostDev: ["192.168.0.105:80801", "192.168.42.2:80809"],
      fileUploadSize: {
        default: {
          size: 2048000,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 2GB байна."
        },
        student: {
          size: 102400,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 100MB байна."
        }
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      register: true,
      helpPageUrl: "http://help.gosmart.mn",
      streamBaseUrl: "https://stream-gate.gosmart.mn/"
    },
    {
      id: 9260,
      name: "НЭКСТ Групп",
      key: "iR4il5S7u0eaX0F0Fi02rQ",
      logo: "media/logo/next.png",
      bgLogin: "assets/img/covid.svg",
      hostPro: ["next.gosmart.mn"],
      hostDev: ["192.168.0.115:80800", "192.168.0.105:80801", "192.168.42.2:80809"],
      fileUploadSize: {
        default: {
          size: 2048000,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 2GB байна."
        },
        student: {
          size: 102400,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 100MB байна."
        }
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      register: true,
      helpPageUrl: "http://help.gosmart.mn",
      streamBaseUrl: "https://stream-gate.gosmart.mn/"
    },
    {
      id: 9262,
      name: "Suld United LLC",
      key: "PeqflMH8GEWkS2NkZYldTg",
      logo: "media/logo/nexus.png",
      bgLogin: "assets/img/nexus.jpg",
      hostPro: ["nexusauto.gosmart.mn"],
      hostDev: ["192.168.0.105:80801", "192.168.42.2:80809"],
      fileUploadSize: {
        default: {
          size: 2048000,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 2GB байна."
        },
        student: {
          size: 102400,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 100MB байна."
        }
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      register: true,
      helpPageUrl: "http://help.gosmart.mn",
      streamBaseUrl: "https://stream-gate.gosmart.mn/",
      baseUrl: "https://mobcore.gosmart.mn/"
    },
    {
      id: 1103,
      name: "EPolice",
      logo: "media/logo/epolice.png",
      bgLogin: "assets/bg/epolice.png",
      skin: "",
      key: "OFImDiThxPeVxcrt1QH3Tz",
      hostPro: ["epv2.gosmart.mn"],
      hostDev: ["192.168.0.115:80880", "192.168.0.100:8080_1"],
      fileUploadSize: {
        default: {
          size: 1048576,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 1гб байна."
        },
        student: {
          size: 30720,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 30мб байна."
        }
      },
      publicPage: {
        has: false
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      //tvr haav
      register: false,

      helpPageUrl: "https://help.gosmart.mn",
      v2BaseUrl: "http://epadmin.gosmart.mn",
      streamBaseUrl: "https://stream-gate.gosmart.mn/",
      hubBaseUrl: "http://103.9.88.248:9090/",
      baseUrl: "https://epconnector.gosmart.mn/"
    },
    {
      id: 9263,
      name: "IPOM",
      key: "4h_JOkAF_kO87_SmEY6gHg",
      logo: "media/logo/ipom.png",
      bgLogin: "assets/img/ipom.jpg",
      hostPro: ["ipbrokerage.ipom.mn"],
      hostDev: ["192.168.0.105:80809", "192.168.0.100:8080_2"],
      fileUploadSize: {
        default: {
          size: 204800,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 200MB байна."
        },
        student: {
          size: 102400,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 100MB байна."
        }
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      publicPage: {
        has: true,
        route: "landingIpom",
        systemName:
          "ОЮУНЫ ӨМЧИЙН ЗУУЧЛАЛ БОЛОН ИТГЭМЖЛЭГДСЭН ТӨЛӨӨЛӨГЧИЙН БҮРТГЭЛИЙН СИСТЕМ",
        mainObjectTypeId: 526,
        mainTypeKey: "ipomBrokerAgentType"
      },
      register: false,
      helpPageUrl: "http://help.gosmart.mn",
      streamBaseUrl: "https://stream-gate.gosmart.mn/",
      baseUrl: "https://mobcore.gosmart.mn/"
      //baseUrl: 'https://devapi.gosmart.mn/',
    },
    {
      id: 9263,
      name: "IPOM",
      key: "4h_JOkAF_kO87_SmEY6gHg",
      logo: "media/logo/ipom.png",
      bgLogin: "assets/img/ipom.jpg",
      hostPro: ["iplicense.ipom.mn"],
      hostDev: ["192.168.0.115:89080", "192.168.0.100:8080_3"],
      fileUploadSize: {
        default: {
          size: 204800,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 200MB байна."
        },
        student: {
          size: 102400,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 100MB байна."
        }
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      publicPage: {
        has: true,
        route: "landingIpom",
        systemName: "ОЮУНЫ ӨМЧИЙН ЛИЦЕНЗИЙН БҮРТГЭЛИЙН МЭДЭЭЛЛИЙН СИСТЕМ",
        mainObjectTypeId: 527,
        mainTypeKey: "ipomCopyRightType"
      },
      register: false,
      helpPageUrl: "http://help.gosmart.mn",
      streamBaseUrl: "https://stream-gate.gosmart.mn/",
      baseUrl: "https://mobcore.gosmart.mn/"
      //baseUrl: 'https://devapi.gosmart.mn/',
    },
    {
      id: 9264,
      name: "Цахим сургалтын платформ",
      key: "ffXfr62SE0GtId4hqhWTKA",
      logo: "media/logo/gs25.png",
      bgLogin: "assets/img/gs25.png",
      hostPro: ["gs25.gosmart.mn"],
      hostDev: ["192.168.0.100:8080_1"],
      fileUploadSize: {
        default: {
          size: 2048000,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 2GB байна."
        },
        student: {
          size: 102400,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 100MB байна."
        }
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      register: false,
      helpPageUrl: "http://help.gosmart.mn",
      streamBaseUrl: "https://stream-gate.gosmart.mn/",
      baseUrl: "https://mobcore.gosmart.mn/"
    },
    {
      id: 9265,
      name: "Банк Санхүүгийн Академи",
      nameShort: "Академи",
      key: "8k8EhKtt7kiB5jB1t_7kMQ",
      skin: "bfa", 
      logo: "media/logo/bfa.png",
      bgLogin: "assets/img/bfa.jpg",
      hostPro: ['e.bfa.mn', 'bfa.gosmart.mn'],
      hostDev: ['192.168.0.115:80x80', 
      '192.168.0.100:8080_2', "192.168.0.173:8080_x", "192.168.0.171:80820_2", "192.168.0.186:8080x"],
      fileUploadSize: {
        default: {
          size: 2048000,
          msg: "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 2GB байна."
        },
        student: {
          size: 102400,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 100MB байна."
        }
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      publicPage: {
        has: false,
        route: "landingShuffle",
        layout: 'bendis'
      },
      register: true,
      helpPageUrl: "http://help.gosmart.mn",
      streamBaseUrl: "https://stream-gate.gosmart.mn/",
      hubBaseUrl: "https://e.bfa.mn/core/",
      baseUrl: "https://e.bfa.mn/mobCore/",

      //  hubBaseUrl: "https://e.bfa.mn/core/",
      //  baseUrl: "https://e.bfa.mn/mobCore/"

      // hubBaseUrl: "https://app.gosmart.mn/coredev/",
      // baseUrl: "https://devapi.gosmart.mn/"
    },
    {
      id: 9274,
      name: "Монголын Өмгөөлөгчдийн холбоо",
      key: "sAKw_rbOfU_J_dQwdPgjDw",
      skin: "",
      logo: "media/logo/ama.png",
      //bgLogin: "assets/img/bfa.jpg",
      hostPro: ['ama.gosmart.mn'],
      hostDev: ['192.168.0.115:80840', 
      '192.168.0.100:808s0'],
      fileUploadSize: {
        default: {
          size: 2048000,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 2GB байна."
        },
        student: {
          size: 102400,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 100MB байна."
        }
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      publicPage: {
        has: false,
        route: "landingShuffle",
        layout: 'bendis'
      },
      register: true,
      helpPageUrl: "http://help.gosmart.mn",
      streamBaseUrl: "https://stream-gate.gosmart.mn/",
      // hubBaseUrl: "https://bfa.gosmart.mn/core/",
      // baseUrl: "https://bfa.gosmart.mn/mobCore/"
    },
    {
      id: 1104,
      name: "Динамик платформ",
      key: "oXSBUpThuoeNxcra7HH3Em",
      skin: "",
      logo: "media/logo/gosmart-05.png",
      bgLogin: "assets/img/bfa.jpg",
      hostPro: ['new.gosmart.mn'],
      hostDev: ['192.168.0.115:80800', '192.168.0.100:8080_1'],
      fileUploadSize: {
        default: {
          size: 2048000,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 2GB байна."
        },
        student: {
          size: 102400,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 100MB байна."
        }
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      publicPage: {
        has: true,
        route: "landingShuffle",
        layout: 'atis'
      },
      register: true,
      helpPageUrl: "http://help.gosmart.mn",
      streamBaseUrl: "https://stream-gate.gosmart.mn/",
      baseUrl: "https://mobcore.gosmart.mn/"
    }
    ,
    {
      id: 9266,
      name: "Грийн групп",
      key: "7oFSnYR_c0mXQJLo5jlT7g",
      skin: "greengroup",
      logo: "media/logo/greengroup.png",
      bgLogin: "assets/img/greengroup.jpg",
      hostPro: ['greengroup.gosmart.mn'],
      hostDev: [
        '192.168.0.115:80800', 
        '192.168.0.100:8080_2'
      ],
      fileUploadSize: {
        default: {
          size: 2048000,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 2GB байна."
        },
        student: {
          size: 102400,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 100MB байна."
        }
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      publicPage: {
        has: false,
        route: "landingShuffle",
        layout: 'bendis'
      },
      register: false,
      helpPageUrl: "http://help.gosmart.mn",
      streamBaseUrl: "https://stream-gate.gosmart.mn/",
      baseUrl: "https://mobcore.gosmart.mn/"
    }
    ,
    {
      id: 9271,
      name: "Дүрслэх урлагийн академи дээд сургууль",
      key: "_KmTQUYcOkqoxqB_tq8k2g",
      skin: "duads",
      logo: "media/logo/duads.png",
      bgLogin: "assets/img/img15.png",
      hostPro: ['mafa.gosmart.mn'],
      hostDev: [
        '192.168.0.115:80801', 
        '192.168.0.100:8080_2'
      ],
      fileUploadSize: {
        default: {
          size: 1024000,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 1GB байна."
        },
        student: {
          size: 102400,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 100MB байна."
        }
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      publicPage: {
        has: false,
        route: "landingShuffle",
        layout: 'bendis'
      },
      register: false,
      helpPageUrl: "http://help.gosmart.mn",
      streamBaseUrl: "https://stream-gate.gosmart.mn/",
      baseUrl: "https://mobcore.gosmart.mn/"
    },    
    {
      id: 9272,
      name: "УБТЗ Залуучуудын төв зөвлөл",
      key: "RAyfiIR2S0CxtGrponbfCg",
      skin: "youthubtz",
      logo: "media/logo/youthubtz.png",
      bgLogin: "assets/img/img15.png",
      hostPro: ['www.youthubtz.mn', 'youthubtz.mn'],
      hostDev: [
        '192.168.0.115:80_80', 
        '192.168.0.100:8080_2'
      ],
      fileUploadSize: {
        default: {
          size: 1024000,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 1GB байна."
        },
        student: {
          size: 102400,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 100MB байна."
        }
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      publicPage: {
        has: false,
        route: "landingShuffle",
        layout: 'bendis'
      },
      register: false,
      helpPageUrl: "http://help.gosmart.mn",
      streamBaseUrl: "https://stream-gate.gosmart.mn/",
      baseUrl: "https://mobcore.gosmart.mn/",
      v2BaseUrl: "https://v2.youthubtz.mn",
    },

    {
      id: 9272,
      name: "УБТЗ Залуучуудын төв зөвлөл",
      key: "RAyfiIR2S0CxtGrponbfCg",
      skin: "is-youth",
      logo: "media/logo/youthubtz.png",
      bgLogin: "assets/img/img15.png",
      hostPro: ['www.uapp.gosmart.mn', 'uapp.gosmart.mn'],
      hostDev: [
        '192.168.0.115:8x080', 
        '192.168.0.164_x:8080',
        '192.168.1.7:8x080'
      ],
      fileUploadSize: {
        default: {
          size: 1024000,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 1GB байна."
        },
        student: {
          size: 102400,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 100MB байна."
        }
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      publicPage: {
        has: false,
        route: "landingShuffle",
        layout: 'bendis'
      },
      directPage: {
        has: true,
        route: "homeyouth",
      },
      register: false,
      helpPageUrl: "http://help.gosmart.mn",
      streamBaseUrl: "https://stream-gate.gosmart.mn/",
      baseUrl: "https://mobcore.gosmart.mn/",
      v2BaseUrl: "https://v2.youthubtz.mn",
    },

    // {
    //   id: 9275,
    //   name: "Цагдаа, дотоодын цэргийн сургалтын нэгдсэн төв",
    //   key: "jSUk2F5JX0KaPdXnKwgdyg",
    //   skin: "",
    //   logo: "media/logo/police.png",
    //   //bgLogin: "assets/img/bfa.jpg",
    //   hostPro: ['police.gosmart.mn'],
    //   hostDev: ['192.168.0.115:80880', 
    //   '192.168.0.100:8080_x'],
    //   fileUploadSize: {
    //     default: {
    //       size: 2048000,
    //       msg: "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 2GB байна."
    //     },
    //     student: {
    //       size: 102400,
    //       msg:
    //         "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 100MB байна."
    //     }
    //   },
    //   learnConfig: {
    //     course: {
    //       showAlert: true
    //     }
    //   },
    //   publicPage: {
    //     has: false,
    //     route: "landingShuffle",
    //     layout: 'bendis'
    //   },
    //   register: false,
    //   helpPageUrl: "http://help.gosmart.mn",
    //   streamBaseUrl: "https://stream-gate.gosmart.mn/",
    //   // hubBaseUrl: "https://bfa.gosmart.mn/core/",
    //   // baseUrl: "https://bfa.gosmart.mn/mobCore/"
    // },
    {
      id: 9281,
      name: "Актив групп",
      key: "ftlPgZFMgUuMs_AeDKc_mA",
      skin: "",
      logo: "media/logo/active.png",
      //bgLogin: "assets/img/bfa.jpg",
      hostPro: ['active.gosmart.mn'],
      hostDev: ['192.168.0.115:8080_x', 
      '192.168.0.100:8080_x'],
      fileUploadSize: {
        default: {
          size: 1024000,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 1GB байна."
        },
        student: {
          size: 10240,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 10MB байна."
        }
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      publicPage: {
        has: false,
        route: "landingShuffle",
        layout: 'bendis'
      },
      register: true,
      helpPageUrl: "http://help.gosmart.mn",
      streamBaseUrl: "https://stream-gate.gosmart.mn/",
      // hubBaseUrl: "https://bfa.gosmart.mn/core/",
      // baseUrl: "https://bfa.gosmart.mn/mobCore/"
    },
    {
      id: 9282,
      name: "Зам тээврийн залуучуудын хөгжлийн зам зөвлөл",
      key: "RS5PVhwsjEm_6OXpHwjsIw",
      skin: "",
      logo: "media/logo/rtydc.png",
      //bgLogin: "assets/img/bfa.jpg",
      hostPro: ['www.rtydc.mn','rtydc.mn'],
      hostDev: ['192.168.0.115:8080_x', 
      '192.168.0.100:8080_x'],
      fileUploadSize: {
        default: {
          size: 2048000,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 2GB байна."
        },
        student: {
          size: 10240,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 10MB байна."
        }
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      publicPage: {
        has: false,
        route: "landingShuffle",
        layout: 'bendis'
      },
      register: true,
      helpPageUrl: "http://help.gosmart.mn",
      streamBaseUrl: "https://stream-gate.gosmart.mn/",
      v2BaseUrl: "http://v2.rtydc.mn",
      // hubBaseUrl: "https://bfa.gosmart.mn/core/",
      // baseUrl: "https://bfa.gosmart.mn/mobCore/",
    },
    {
      id: 9283,
      name: "",
      key: "qulEvTkHkUqd4VCnJh1TUw",
      skin: "magic",
      logo: "media/logo/magic.png",
      //bgLogin: "assets/img/bfa.jpg",
      hostPro: ['magicchoice.magicgroup.mn'],
      hostDev: ['192.168.0.115:80809', 
      '192.168.0.100:8080_x'],
      fileUploadSize: {
        default: {
          size: 2048000,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 2GB байна."
        },
        student: {
          size: 102400,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 100MB байна."
        }
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      publicPage: {
        has: false,
        route: "landingShuffle",
        layout: 'bendis'
      },
      register: true,
      helpPageUrl: "http://help.gosmart.mn",
      streamBaseUrl: "https://stream-gate.gosmart.mn/",
      //v2BaseUrl: "http://app.gosmart.mn",
      // hubBaseUrl: "https://bfa.gosmart.mn/core/",
      // baseUrl: "https://bfa.gosmart.mn/mobCore/",
    },
    {
      id: 9284,
      name: "Surgalt.opengov.mn",
      key: "o9debinJsECMKBt8H49KCw",
      skin: "dataland-mofa",
      logo: "media/logo/dataland-mofa.png",
      bgLogin: "assets/img/dataland.png",
      hostPro: ['surgalt.opengov.mn', 'mofa.gosmart.mn'],
      hostDev: ['192.168.0.115:80980', 
      '192.168.0.100:8080_x'],
      fileUploadSize: {
        default: {
          size: 2048000,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 2GB байна."
        },
        student: {
          size: 102400,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 100MB байна."
        }
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      publicPage: {
        has: false,
        route: "landingShuffle",
        layout: 'bendis'
      },
      register: false,
      hasStreamServer: false,
      helpPageUrl: "http://help.gosmart.mn",
      //streamBaseUrl: "https://stream-gate.gosmart.mn/",
      PDFJS_URL: "https://mofa-cdn.gosmart.mn/static/pdfobject/web/viewer.html",
      v2BaseUrl: "https://mofa-app.gosmart.mn",
       hubBaseUrl: "https://mofa.gosmart.mn/core/",
       baseUrl: "https://mofa.gosmart.mn/mobCore/",
    },

    {
      id: 9285,
      name: "Эрдмийн ундарга сургалтын төв",
      key: "Ll4G3PRHT0GnjbGr3ou_bw",
      //skin: "magic",
      logo: "media/logo/erdem.png",
      //bgLogin: "assets/img/bfa.jpg",
      hostPro: ['erdem.gosmart.mn'],
      hostDev: ['192.168.0.115:80x80', 
      '192.168.0.100:8080_x'],
      fileUploadSize: {
        default: {
          size: 2048000,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 2GB байна."
        },
        student: {
          size: 102400,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 100MB байна."
        }
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      publicPage: {
        has: false,
        route: "landingShuffle",
        layout: 'bendis'
      },
      register: true,
      helpPageUrl: "http://help.gosmart.mn",
      streamBaseUrl: "https://stream-gate.gosmart.mn/",
      //v2BaseUrl: "http://app.gosmart.mn",
      // hubBaseUrl: "https://bfa.gosmart.mn/core/",
      // baseUrl: "https://bfa.gosmart.mn/mobCore/",
    },
    {
      id: 9287,
      name: "ХХААХҮЯ - ХЯНАЛТ-ШИНЖИЛГЭЭ, ҮНЭЛГЭЭ, ДОТООД АУДИТ",
      key: "Hk9SjjRuwECDcljM3342pQ",
      skin: "audit",
      logo: "media/logo/soyombo.png",
      bgLogin: "assets/bg/audit.jpg",
      hostPro: ['audit.gosmart.mn', 'audit-mofa.gosmart.mn', 'audit.mofa.gov.mn'],
      hostDev: ["192.168.0.115:80800", 
      '192.168.0.100:8080_x', '192.168.0.164_x:8080', '192.168.0.171:8080'],
      fileUploadSize: {
        default: {
          size: 2048000,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 2GB байна."
        },
        student: {
          size: 102400,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 100MB байна."
        }
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      publicPage: {
        has: false,
        route: "landingShuffle",
        layout: 'bendis'
      },
      register: false,
      helpPageUrl: "https://audit-mofa-cdn.gosmart.mn/static/audit-help.pdf",
      
      hubBaseUrl: "https://audit-mofa.gosmart.mn/core/",
      baseUrl: "https://audit-mofa.gosmart.mn/mobcore/",

      PDFJS_URL: "https://audit-mofa-cdn.gosmart.mn/static/pdfobject/web/viewer.html",
      v2BaseUrl: "https://audit-mofa-app.gosmart.mn",
      hasStreamServer: false,
    },

    {
      id: 9164,
      name: "Замын хөдөлгөөний мэдээлэл",
      key: "csxbNQ6PLk_z_Hw02ludeL",
      logo: "media/logo/mofa.svg",
      hostPro: ['zhut.gosmart.mn'],
      hostDev: ['192.168.0.115:8x080', 
      '192.168.0.100:8080_x', '192.168.0.164_:8080'],
      fileUploadSize: {
        default: {
          size: 2048000,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 2GB байна."
        },
        student: {
          size: 102400,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 100MB байна."
        }
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      directPage:{
        has: true,
        route: 'penaltyDashboard'
      },
      publicPage: {
        has: false,
        route: "landingShuffle",
        layout: 'bendis'
      },
      register: true,
      helpPageUrl: "http://help.gosmart.mn",
      streamBaseUrl: "https://stream-gate.gosmart.mn/",
      //v2BaseUrl: "http://app.gosmart.mn",
      hubBaseUrl: "http://103.9.88.247/core/",
      baseUrl: "http://103.9.88.247:2020/",

      // hubBaseUrl: "https://app.gosmart.mn/coredev/",
      // baseUrl: "https://devapi.gosmart.mn/"
    },

    {
      id: 9290,
      name: "ЭЧВОД-1",
      logo: "media/logo/echvod1.png",
      bgLogin: "assets/img/img15.png",
      skin: "",
      key: "4PLBfzTFa0O_R_gJ0ub9Ow",

      hostPro: ["echvod1.gosmart.mn"],
      hostDev: [
        "192.168.0.105:8080_s",
        "192.168.0.115:80x80",
        "192.168.0.100:8080_j",
        "192.168.42.2:8081",
        "192.168.0.100:8080_tch"
      ],
      fileUploadSize: {
        default: {
          size: 1048576,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 1гб байна."
        },
        student: {
          size: 1,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 1kb байна."
        }
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      helpPageUrl: "http://help.gosmart.mn",
      streamBaseUrl: "https://stream-gate.gosmart.mn/",
      // hubBaseUrl: 'https://www.my-railway.com/core/',
      // baseUrl: 'https://my-railway.com/mobCore/',
      v2BaseUrl: "https://v2.echvod1.gosmart.mn",
      //hubBaseUrl: 'https://app.gosmart.mn/coredev/',
      //baseUrl: 'https://devapi.gosmart.mn/',
    },
    {
      id: 9291,
      name: "ХХҮЕГ",
      logo: "media/logo/halamj.png",
      bgLogin: "assets/img/covid.svg",
      skin: "",
      key: "KV8lkRKi_EWjV5MHOeB7Mg",
      hostPro: ["hudulmur.gosmart.mn", "surgalt.hudulmur-halamj.gov.mn"],
      hostDev: ["192.168.0.115:80880", "192.168.0.105:80801"],
      fileUploadSize: {
        default: {
          size: 2048000,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 2GB байна."
        },
        student: {
          size: 30720,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 30мб байна."
        }
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      //register: true,
      PDFJS_URL: "https://cdn-surgalt.hudulmur-halamj.gov.mn/static/pdfobject/web/viewer.html",
      v2BaseUrl: "http://hudulmur-app.gosmart.mn",
      hasStreamServer: false,
      helpPageUrl: "http://help.gosmart.mn",
      streamBaseUrl: "",
      hubBaseUrl: "https://surgalt.hudulmur-halamj.gov.mn/core/",
      baseUrl: "https://surgalt.hudulmur-halamj.gov.mn/mobCore/"
    },

    {
      id: 9292,
      name: "ЗТХТ",
      // logo: "media/logo/halamj.png",
      // bgLogin: "assets/img/covid.svg",
      skin: "",
      key: "FN5PtdEgU0mKXK42q2KSog",
      hostPro: ["dynamic.roadpay.mn", "rtdc-erp.gosmart.mn"],
      hostDev: ["192.168.0.115:80805", "192.168.0.105:80801"],
      fileUploadSize: {
        default: {
          size: 2048000,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 2GB байна."
        },
        student: {
          size: 30720,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 30мб байна."
        }
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      //register: true,
      // PDFJS_URL: "https://cdn-surgalt.hudulmur-halamj.gov.mn/static/pdfobject/web/viewer.html",
      // v2BaseUrl: "http://hudulmur-app.gosmart.mn",
      // hasStreamServer: false,
      // helpPageUrl: "http://help.gosmart.mn",
      // streamBaseUrl: "",
      hubBaseUrl: "https://rtdc.gosmart.mn/core/",
      baseUrl: "https://rtdc.gosmart.mn/mobCore/"
    },


    {
      //# mori dashboard shinjleh ugaan tehnology innovatsiin negdsen tsahim svljee
      id: 98,
      name: "Динамик МОРИ",
      //key: "zIGhSWMcrLTeOUvByGtMr1",
      key: "br_bHWaQ2k2TqS7__VInhZ",
      logo: "media/icon.png",
      skin: "is-mori",
      publicPage: {
        has: false,
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      hostPro: [ "mori.gosmart.mn" ],
      hostDev: [ "192.168.0.115:88080", "172.20.10.3:8080" ],
      fileUploadSize: {
        default: {
          size: 204800,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 200мб байна."
        },
        student: {
          size: 102400,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 100мб байна."
        }
      },
      helpPageUrl: "http://help.gosmart.mn",
      streamBaseUrl: "https://stream-gate.gosmart.mn/",
      hubBaseUrl: "https://app.gosmart.mn/coredev/",
      baseUrl: "https://devapi.gosmart.mn/"
    },

    {
      id: 9298,
      name: "СУДЛААЧИЙН МЭДЭЭЛЛИЙН САН",
      key: "YIIwSTzerUK8VA3slcRz3A",
      logo: "media/logo/stfp.png",
      bgLogin: "assets/img/sc.png",
      skin: "is-stf",
      publicPage: {
        has: true,
        route: 'landingPage'
      },
      register: true,
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      hostPro: [ "project.stf.gov.mn", "project-stf.gosmart.mn" ],
      hostDev: [ "192.168.0.115:80x80", "192.168.1.7:8080", "172.20.10.3:8080",
      "192.168.0.100x:80x80", "192.168.0.186:8080"],
      fileUploadSize: {
        default: {
          size: 204800,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 200мб байна."
        },
        student: {
          size: 102400,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 100мб байна."
        }
      },

      hubBaseUrl: "https://project-stf.gosmart.mn/core/",
      baseUrl: "https://project-stf.gosmart.mn/mobCore/"
    },
    {
      id: 9298,
      name: "Докторын зөвлөл",
      key: "YIIwSTzerUK8VA3slcRz3A",
      logo: "media/logo/stfp.png",
      bgLogin: "assets/img/sc.png",
      skin: "is-stf",
      publicPage: {
        has: false,
        route: 'landingPage'
      },
      register: true,
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      hostPro: [ "doctor.stf.gov.mn"],
      hostDev: [ "192.168.0.115:8080"],
      fileUploadSize: {
        default: {
          size: 204800,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 200мб байна."
        },
        student: {
          size: 102400,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 100мб байна."
        }
      },

      hubBaseUrl: "https://project-stf.gosmart.mn/core/",
      baseUrl: "https://project-stf.gosmart.mn/mobCore/"
    },
    // {
    //   id: 9313,
    //   name: "Боловсрол, шинжлэх ухааны яам",
    //   key: "yUtbesVhbUS84GqmjXl9Tg",
    //   logo: "media/logo/stfp.png",
    //   bgLogin: "assets/img/sc.png",
    //   skin: "is-stf",
    //   publicPage: {
    //     has: true,
    //     route: 'landingPage'
    //   },
    //   register: true,
    //   learnConfig: {
    //     course: {
    //       showAlert: true
    //     }
    //   },
    //   hostPro: [ "project.stf.goxxv.mn", "project-stf.gosmart.mn" ],
    //   hostDev: [ "192.168.0.115:80x80", "192.168.1.7:8080", "172.20.10.3:8080",
    //   "192.168.0.100x:8080", ],
    //   fileUploadSize: {
    //     default: {
    //       size: 204800,
    //       msg:
    //         "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 200мб байна."
    //     },
    //     student: {
    //       size: 102400,
    //       msg:
    //         "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 100мб байна."
    //     }
    //   },

    //   hubBaseUrl: "https://project-stf.gosmart.mn/core/",
    //   baseUrl: "https://project-stf.gosmart.mn/mobCore/"
    // },
    {
      id: 9298,
      name: "Шинжлэх ухааны салбарын түлхүүр үгийн сан",
      key: "YIIwSTzerUK8VA3slcRz3A",
      logo: "media/logo/ac_icon.png",
      bgLogin: "assets/img/stf.png",
      skin: "is-stf",
      publicPage: {
        has: false,
      },
      limitedRoutes: [
        '_systemLocTypeConfig'
      ],
      register: true,
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      hostPro: [ "toli.ac.mn" ],
      hostDev: [ "192.168.0.115:80x80", "172.20.10.3:8080",
      "192.168.0.168:8080",],
      fileUploadSize: {
        default: {
          size: 204800,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 200мб байна."
        },
        student: {
          size: 102400,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 100мб байна."
        }
      },

      hubBaseUrl: "https://project-stf.gosmart.mn/core/",
      baseUrl: "https://project-stf.gosmart.mn/mobCore/"
    },

    {
      //# mori dashboard shinjleh ugaan tehnology innovatsiin negdsen tsahim svljee
      id: 9299,
      name: "Тогтвортой ноос ноолуурын эвсэл",
      key: "xOcCffvn4kSBLzIGjLd4vg",
      logo: "media/logo/nartc.png",
      skin: "",
      publicPage: {
        has: false,
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      hostPro: [ "training.nartc.mn", "training.sustainablefibre.mn" ],
      hostDev: [ "192.168.0.115:80x80", "172.20.10.3:8080" ],
      fileUploadSize: {
        default: {
          size: 204800,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 200мб байна."
        },
        student: {
          size: 102400,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 100мб байна."
        }
      },
      register: true,
      helpPageUrl: "https://help.gosmart.mn",
      streamBaseUrl: "https://stream-gate.gosmart.mn/",
      hubBaseUrl: "https://mobcoreapi.gosmart.mn/",
      baseUrl: "https://mobcore.gosmart.mn/"
    },

    {
      id: 9300,
      name: "Тэтгэлгийн нэгдсэн систем",
      key: "hO1esH8BKkCDMYp3ysB7wg",
      logo: "media/logo/elf.png",
      skin: "",
      publicPage: {
        has: false,
      },
      register: true,
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      hostPro: [ "elf.gosmart.mn" ],
      hostDev: [ "192.168.0.115:80x80", "172.20.10.3:8080" ],
      fileUploadSize: {
        default: {
          size: 204800,
          msg: "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 200мб байна."
        },
        student: {
          size: 102400,
          msg: "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 100мб байна."
        }
      },

      hubBaseUrl: "https://elf.gosmart.mn/core/",
      baseUrl: "https://elf.gosmart.mn/mobCore/"
    },

    {
      id: 9306,
      name: "CENTURY 21",
      key: "cBXeHw9r2UejtEtehc9Gaw",
      logo: "media/logo/c21.png",
      skin: "",
      publicPage: {
        has: false,
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      hostPro: [ "hub.c21.mn"],
      hostDev: [ "192.168.0.115:80x80", "172.20.10.3:8080" ],
      fileUploadSize: {
        default: {
          size: 204800,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 200мб байна."
        },
        student: {
          size: 102400,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 100мб байна."
        }
      },
      register: false,
      helpPageUrl: "https://help.gosmart.mn",
      streamBaseUrl: "https://stream-gate.gosmart.mn/",
      hubBaseUrl: "https://mobcoreapi.gosmart.mn/",
      baseUrl: "https://mobcore.gosmart.mn/"
    },

    {
      id: 9307,
      name: "Шүүхийн ерөнхий зөвлөл",
      key: "uUn_85_69USV9t9ZUmeGeg",
      logo: "media/logo/jud.png",
      bgLogin: "assets/img/jud.png",
      skin: "is-jud",
      publicPage: {
        has: false,
        route: "landingPage"
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      hostPro: [ "edu.judcouncil.mn", "103.11.195.40", "192.168.99.9", "192.168.0.180", "jud.gosmart.mn"],
      hostDev: [ "192.168.0.115:80x80", "172.20.10.3:8080",
       "192.168.0.164:8080_x"
     ],
      fileUploadSize: {
        default: {
          size: 2048000,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 2GB байна."
        },
        student: {
          size: 102400,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 100мб байна."
        }
      },
      register: true,
      helpPageUrl: "http://edu-help.judcouncil.mn",

      hasStreamServer: true,
      reportBaseUrl: "http://103.11.195.40:8091/",
      streamBaseUrl: "http://103.11.195.40:1935/",

      PDFJS_URL: 'http://103.11.195.40:8086/static/pdfobject/web/viewer.html',
      cdnBaseUrl: 'http://103.11.195.40:8086/',

      // hubBaseUrl: "https://mobcoreapi.gosmart.mn/",
      // baseUrl: "https://mobcore.gosmart.mn/"

      // hubBaseUrl: "http://edu.judcouncil.mn/core/",
      // baseUrl: "http://edu.judcouncil.mn/mobcore/"

      hubBaseUrl: "http://103.11.195.40/core/",
      baseUrl: "http://103.11.195.40/mobcore/"
    },

    {
      id: 9309,
      name: "Витафит групп",
      key: "0tQsXapmpEu5GMyDSbclBA",
      logo: "media/logo/vitafit.png",
      skin: "",
      publicPage: {
        has: false,
        route: "landingPage"
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      hostPro: [ "vitafit.gosmart.mn"],
      hostDev: [ "192.168.0.115:8x080", "172.20.10.3:8080" ],
      fileUploadSize: {
        default: {
          size: 2500000,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 2.5GB байна."
        },
        student: {
          size: 102400,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 100мб байна."
        }
      },
      register: true,
      helpPageUrl: "http://help.gosmart.mn",
      streamBaseUrl: "https://stream-gate.gosmart.mn/",

      hubBaseUrl: "https://traininghub.gosmart.mn/core/",
      baseUrl: "https://traininghub.gosmart.mn/mobCore/"
    },

    {
      id: 9310,
      name: "Шүүх шинжилгээний ерөнхий газар",
      key: "zV9NaDEYTEuq23EBk8QWeg",
      logo: "media/logo/nfa.png",
      skin: "",
      publicPage: {
        has: false,
        route: "landingPage"
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      hostPro: [ "nfa.gosmart.mn"],
      hostDev: [ "192.168.0.115:80x80", "172.20.10.3:8080" ],
      fileUploadSize: {
        default: {
          size: 204800,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 200мб байна."
        },
        student: {
          size: 102400,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 100мб байна."
        }
      },
      register: true,
      helpPageUrl: "http://help.gosmart.mn",
      streamBaseUrl: "https://stream-gate.gosmart.mn/",

      hubBaseUrl: "https://traininghub.gosmart.mn/core/",
      baseUrl: "https://traininghub.gosmart.mn/mobCore/"
    },

    {
      id: 9311,
      name: "Монголын үнэт цаасны арилжаа эрхлэгчдийн холбоо",
      nameShort: "МҮЦАЭХ",
      key: "Aw96iFc6M0CbH0tPueNbNA",
      logo: "media/logo/masd.png",
      skin: "",
      publicPage: {
        has: false,
        route: "landingPage"
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      hostPro: [ "e.masd.mn"],
      hostDev: [ "192.168.0.115:80x80", "172.20.10.3:8080" ],
      fileUploadSize: {
        default: {
          size: 204800,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 200мб байна."
        },
        student: {
          size: 102400,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 100мб байна."
        }
      },

      register: true,
      helpPageUrl: "http://help.gosmart.mn",
      streamBaseUrl: "https://stream-gate.gosmart.mn/",
      //baseUrl: "https://mobcore.gosmart.mn/"
      hubBaseUrl: "https://e.masd.mn/core/",
      baseUrl: "https://e.masd.mn/mobCore/"
    },

    {
      id: 9312,
      name: "Терроризмтой тэмцэх зөвлөл",
      key: "1xP7K5L3aUKHOsSGrqsr5g",
      logo: "media/logo/nctc.png",
      skin: "",
      publicPage: {
        has: false,
        route: "landingPage"
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      hostPro: [ "surgalt.nctc.gov.mn"],
      hostDev: [ "192.168.0.115:80x80", "172.20.10.3:8080" ],
      fileUploadSize: {
        default: {
          size: 204800,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 200мб байна."
        },
        student: {
          size: 102400,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 100мб байна."
        }
      },

      register: true,
      helpPageUrl: "http://help.gosmart.mn",
      streamBaseUrl: "https://stream-gate.gosmart.mn/",
      baseUrl: "https://mobcore.gosmart.mn/"
    },

    {
      id: 9315,
      name: "Edu Gov",
      key: "RECGYYAuGEmfNA0o_t16pA",
      logo: "media/logo/onoo.png",
      skin: "",
      publicPage: {
        has: false,
        route: "landingPage"
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      hostPro: [ "surgalt.nctc.gov.mn", "erp.onoo.mn", "surgalt.onoo.mn"],
      hostDev: [ "192.168.0.115:80x80", "172.20.10.3:8080" ],
      fileUploadSize: {
        default: {
          size: 204800,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 200мб байна."
        },
        student: {
          size: 102400,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 100мб байна."
        }
      },

      register: true,
      helpPageUrl: "http://help.gosmart.mn",
      streamBaseUrl: "https://stream-gate.gosmart.mn/",
      baseUrl: "https://mobcore.gosmart.mn/"
    },
    {
      id: 9275,
      name: "Цагдаагийн ерөнхий газрын цахим сургалт",
      nameShort: "ЦЕГ цахим сургалт",
      key: "jSUk2F5JX0KaPdXnKwgdyg",
      skin: "",
      logo: "media/logo/police.png",
      //bgLogin: "assets/img/bfa.jpg",
      hostPro: ['police.gosmart.mn', 'esurgalt.police.gov.mn'],
      hostDev: ['192.168.0.115:80x80', 'http://192.168.0.177:8081/',
      '192.168.0.100:8080_x'],
      fileUploadSize: {
        default: {
          size: 2048000,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 2GB байна."
        },
        student: {
          size: 102400,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 100MB байна."
        }
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      publicPage: {
        has: false,
        route: "landingShuffle",
        layout: 'bendis'
      },
      register: false,
      helpPageUrl: "http://help.gosmart.mn",
      streamBaseUrl: "https://stream235.gosmart.mn/",
      hasStreamServer: true,
      cdnBaseUrl: 'https://police-cdn.gosmart.mn/',
      hubBaseUrl: "https://esurgalt.police.gov.mn/core/",
      baseUrl: "https://esurgalt.police.gov.mn/mobCore/"

    },

    {
      id: 9141,
      name: "Мэдээлэл, Технологийн Үндэсний Парк",
      key: "T9LuKWNQVj3QSZXxZ0mNZa",
      //skin: "magic",
      logo: "media/logo/itpark.png",
      //bgLogin: "assets/img/bfa.jpg",
      hostPro: ['itpark.gosmart.mn'],
      hostDev: ['192.168.0.115:8x080', 
      '192.168.0.100:8080_x'],
      fileUploadSize: {
        default: {
          size: 2048000,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 2GB байна."
        },
        student: {
          size: 102400,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 100MB байна."
        }
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      publicPage: {
        has: false,
        route: "landingShuffle",
        layout: 'bendis'
      },
      register: true,
      helpPageUrl: "http://help.gosmart.mn",
      streamBaseUrl: "https://stream-gate.gosmart.mn/",
      v2BaseUrl: "https://v2.itpark.gosmart.mn",
       hubBaseUrl: "https://itpark.gosmart.mn/core/",
       baseUrl: "https://itpark.gosmart.mn/mobCore/",
    },

    {
      id: 9343,
      name: "Max Group",
      key: "Yz3wDtxAS0O29YjDMN_rYg",
      logo: "media/logo/maxgroup.png",
      skin: "",
      publicPage: {
        has: false,
        route: "landingPage"
      },
      learnConfig: {
        course: {
          showAlert: true
        }
      },
      hostPro: [ "maxgroup.gosmart.mn"],
      hostDev: [ "192.168.0.115:8x080", "172.20.10.3:8080" ],
      fileUploadSize: {
        default: {
          size: 204800,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 200мб байна."
        },
        student: {
          size: 102400,
          msg:
            "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 100мб байна."
        }
      },

      register: true,
      helpPageUrl: "http://help.gosmart.mn",
      streamBaseUrl: "https://stream-gate.gosmart.mn/",
      baseUrl: "https://mobcore.gosmart.mn/"
    },
  ],
  roleDefaultPages: [
    {
      id: 1,
      title: "Динамик Платформ",
      roles: [
        {
          icon: "home",
          title: "Эхлэл",
          role: ["officehome"],
          rawLink: "/wall"
        }
      ]
    },
    {
      id: 301,
      title: "Шалган зааварлагчийн модуль",
      roles: [
        {
          icon: "bar-chart-2",
          title: "Хянах самбар",
          role: ["tr_chief", "tr_tch_chief", "tr_trainer"],
          rawLink: "/tr/dashboard",
        },
        // {
        //   icon: "users",
        //   title: "Шалган зааварчилгаа",
        //   role: ["tr_trainer", "tr_driver"],
        //   rawLink: "/tr/travel/557/0/0/0",
        // },
        {
          icon: "alert-circle",
          title: "Машинчийн санамж",
          role: ["tr_trainer", "tr_tch_chief", "tr_driver"],
          rawLink: "/tr/sanamj/559/0/0/0/0/0",
        },
        {
          icon: "slack",
          title: "Үүрэг даалгавар",
          role: ["tr_trainer", "tr_tch_chief", "tr_driver"],
          rawLink: "/tr/assign/333/0/0/0/0/0",
        }
      ]
    },
    {
      id: 2,
      title: "Сургалтын систем",
      roles: [
        {
          icon: "database",
          title: "Сургалтын админ",
          role: ["learningadmin"],
          rawLink: "/lms/admin/115/0/0"
        },
        {
          icon: "book",
          title: "Багш",
          role: ["learningteacher"],
          rawLink: "/lms/dashboard"
        },
        {
          icon: "award",
          title: "Суралцагч",
          role: [
            "learningstudent",
            "learningoffice",
            "learningteacher",
            "learningadmin"
          ],
          rawLink: "/lms/participant"
        },
        {
          icon: "book-open",
          title: "Номын санч",
          role: ["learnlibraryorder"],
          rawLink: "/lms/library/0/0/null/4"
        },
        {
          icon: "pie-chart",
          title: "Санал асуулга",
          role: ["learnpoll"],
          rawLink: "/goform/pollAdmin",
          version: 2,
          v2: {
            type: 1,
            name: "formPollAdmin",
            link: "/goform/pollAdmin"
          },
        },   
        {
          icon: "book-open",
          title: "Тайлан",
          role: ["reporttagviewer"],
          rawLink: "/report/list/451/0/0"
        },     
        {
          icon: "activity",
          title: "Хөрөнгө",
          role: ["asset"],
          rawLink: "/asset/dashboard"
        }
      ]
    },


    {
      id: 1010,
      title: "Төслийн бүртгэлийн систем",
      roles: [
        {
          icon: "database",
          title: "Админ",
          role: ["stf_proj_admin"],
          rawLink: "/stf/dashboard"
        },
        {
          icon: "book",
          title: "Шинжээч",
          role: ["stf_proj_shinjeech"],
          rawLink: "/stf/dashboard"
        },
        {
          icon: "award",
          title: "Судлаач",
          role: ["stf_proj_sudlaach"],
          rawLink: "/stf/researcher"
        },
      ]
    },

    {
      id: 1020,
      title: "Боловсролын зээлийн систем",
      roles: [
        {
          icon: "pie-chart",
          title: "Удирдлагын самбар",
          role: ["elf_admin"],
          rawLink: "/elf/dashboard"
        },
        {
          icon: "award",
          title: "Суралцагч",
          role: ["elf_student"],
          rawLink: "/elf/student"
        },
      ]
    },

    {
      id: 4,
      title: "Албан хэрэг хөтлөлт",
      roles: [
        {
          icon: "file-text",
          title: "Ирсэн бичгийн бүртгэл",
          version: 2,
          v2: {
            type: 1,
            name: "inDocList",
            link: "/archive/inDocList"
          },
          role: ["archive", "archiveadmin"],
          rawLink: "/archive/inDocList"
        },
        {
          icon: "file-text",
          title: "Явсан бичгийн бүртгэл",
          version: 2,
          v2: {
            type: 1,
            name: "outDocList",
            link: "/archive/outDocList"
          },
          role: ["archive", "archiveadmin"],
          rawLink: "/archive/outDocList"
        }
      ]
    },
    {
      id: 8,
      title: "Аудит",
      roles: [
        {
          icon: "award",
          title: "Аудит",
          role: ["audit"],
          rawLink: "/audit/dashboard",
        }
      ]
    },
    {
      id: 5,
      title: "Хүний нөөц, Гишүүнчлэл",
      roles: [
        {
          icon: "user-plus",
          title: "Хүний нөөц",
          role: ["hradmin"],
          rawLink: "/hr/list/138"
        },
        {
          icon: "user-plus",
          title: "Гишүүнчлэл",
          role: ["memberadmin", "membermanager"],
          rawLink: "/member/list/390"
        },
        {
          icon: "user-plus",
          title: "Гишүүн хайх",
          role: ["memberdb"],
          version: 2,
          v2: {
            type: 1,
            name: "memberDb",
            link: "/member/db"
          },
          rawLink: "/member/db"
        }
      ]
    },
    {
      id: 5,
      title: "ТАДС",
      roles: [
        {
          icon: "user-plus",
          title: "ТАДС Админ",
          role: ["tadsadmin"],
          rawLink: "/tadsadmin/sequence/512/0/0"
        }
      ]
    },
    {
      id: 6,
      title: "Оюуны өмч",
      roles: [
        {
          icon: "award",
          title: "Зуучлалын үйл ажиллагаа эрхлэгч",
          role: ["ipombroker"],
          rawLink: "/ipom/brokers/95326"
          //rawLink: '/ipom/broker/526/0/0',
        },
        {
          icon: "briefcase",
          title: "Итгэмжлэгдсэн төлөөлөгч",
          role: ["ipomagent"],
          rawLink: "/ipom/agents/95327"
          //rawLink: '/ipom/agent/527/0/0',
        },
        {
          icon: "award",
          title: "Бүтээгдэхүүний загвар",
          role: ["ipombuteegdehuun"],
          rawLink: "/ipom/product/99416"
        },
        {
          icon: "award",
          title: "Ашигтай загвар",
          role: ["ipomashigtaizagvar"],
          rawLink: "/ipom/ashigtai_zagvar/99415"
        },
        {
          icon: "award",
          title: "Шинэ бүтээл",
          role: ["ipomshinebuteel"],
          rawLink: "/ipom/shine_buteel/99414"
        },
        {
          icon: "award",
          title: "Барааны тэмдэг",
          role: ["ipommark"],
          rawLink: "/ipom/baraanii_temdeg/99417"
        },
        {
          icon: "award",
          title: "Зохиогчийн эрх",
          role: ["ipomcopyright"],
          rawLink: "/ipom/copyright/99418"
        }
      ]
    },
    {
      id: 7,
      title: "Аттестатчилал",
      roles: [
        {
          icon: "award",
          title: "Аттестатчилал",
          role: ["mnuacattest", "mnuacattestkomiss", "mnuacattestown", "mnuacattesttenkhim"],
          rawLink: "/attestat/list/533/0/0/0",
          version: 8501,
        }
      ]
    },    

    {
      id: 201,
      title: "mori",
      roles: [
        {
          icon: "award",
          title: "mori",
          role: ["mori"],
          rawLink: "/mori/dashboard",
        }
      ]
    },
  ]
};
